export const womenEntrepreneursDocuments = [
  {
    id: 1,
    title: 'Treaty on the Functioning of the European Union – Article 8',
    topic: 'Gender equality / Women',
    category: 'Primary law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu'
  },
  {
    id: 2,
    title: 'Treaty on the Functioning of the European Union – Article 10',
    topic: 'Non-discrimination',
    category: 'Primary law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu'
  },
  {
    id: 3,
    title: 'Treaty on the Functioning of the European Union – Article 19',
    topic: 'Equal opportunities',
    category: 'Primary law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu'
  },
  {
    id: 4,
    title: 'Treaty on the Functioning of the European Union – Article 153',
    topic: 'Employment and social policy',
    category: 'Primary law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu'
  },
  {
    id: 5,
    title: 'Treaty on the Functioning of the European Union – Article 157',
    topic: 'Equal pay',
    category: 'Primary law',
    website: 'eur-lex.europa.eu',
    url: 'https://eur-lex.europa.eu'
  },
  {
    id: 6,
    title: 'EU Gender Equality Strategy 2020–2025',
    topic: 'Gender equality',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url: 'https://commission.europa.eu'
  },
  {
    id: 7,
    title: 'Women Entrepreneurship Platform (WEP)',
    topic: 'Entrepreneurship',
    category: 'Support initiatives',
    website: 'ec.europa.eu',
    url: 'https://ec.europa.eu'
  },
  {
    id: 8,
    title: 'EU Strategy for SMEs',
    topic: 'SMEs / Entrepreneurship',
    category: 'Policy & Strategic Frameworks',
    website: 'commission.europa.eu',
    url: 'https://commission.europa.eu'
  },
  {
    id: 9,
    title: 'Digital Europe Programme',
    topic: 'Digitalisation',
    category: 'Funding programme',
    website: 'digital-strategy.ec.europa.eu',
    url: 'https://digital-strategy.ec.europa.eu'
  },
  {
    id: 10,
    title: 'Horizon Europe Programme',
    topic: 'Innovation',
    category: 'Funding programme',
    website: 'research-and-innovation.ec.europa.eu',
    url: 'https://research-and-innovation.ec.europa.eu'
  },
  {
    id: 11,
    title: 'European Innovation Council (EIC)',
    topic: 'Innovation',
    category: 'Support initiatives',
    website: 'eic.ec.europa.eu',
    url: 'https://eic.ec.europa.eu'
  },
  {
    id: 12,
    title: 'European Social Fund Plus (ESF+)',
    topic: 'Employment / Inclusion',
    category: 'Funding programme',
    website: 'ec.europa.eu',
    url: 'https://ec.europa.eu'
  }
]
